import { OENActionCommand } from "../enums/oe-action-command.enum";

export class OEActionCommandModel {
  // must
  public command: OENActionCommand;
  public value: any;
  public isBmark: boolean = false;

  constructor(_command: OENActionCommand, _value?: any, _isBmark: boolean = false) {
    this.command = _command;
    this.value = _value != null ? _value : null;
    this.isBmark = _isBmark;
  }
}
